export const TABS = {
  PERFORMANCE: 'performance',
  FORMS: 'forms',
  ATTRIBUTED_FORMS: 'attributed-forms',
  RESULTS: 'results'
};